import HorarioFuncionamentoModal from "../../HorarioFuncionamento";

export default function HorarioFuncionamentoTab() {
    return (
        <div>
            <div className="w-full p-6">
                <div className="space-y-2">
                    <h2 className="text-xl md:text-2xl font-semibold text-gray-900">Horários de Funcionamento</h2>
                    <p className="text-gray-700">Defina os horários de abertura e fechamento do seu estabelecimento.</p>

                    <HorarioFuncionamentoModal />
                </div>
            </div>
        </div>
    );
}